import styled from '@emotion/styled';
import { StyledProps, Theme } from './Icon.types';
import { color } from 'styled-system';

export const Icon = styled.svg<StyledProps, Theme>`
  ${color}
`;

export default Icon;
